import { action } from "typesafe-actions";
import { ExtDdaAccount } from "types";

export const ADD_EXTERNAL_ACCOUNTS = "ADD_EXTERNAL_ACCOUNTS";

export const addExternalAccounts = (payload: ExtDdaAccount[]) =>
  action(ADD_EXTERNAL_ACCOUNTS, payload);
